<app-header>
  <div class="card p-5">
    <div class="card-body" class="text-center">
      <h2 class="title text-primary">Feed No Longer Available</h2>
      <p class="body-text mt-4">
          This feed is no longer available.<br>
          A new feed must be generated.
      </p>
    </div>
  </div>
</app-header>
